import { render, staticRenderFns } from "./ContratacoesDash.vue?vue&type=template&id=adf8e3e6"
import script from "./ContratacoesDash.vue?vue&type=script&lang=js"
export * from "./ContratacoesDash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports